/// <reference path="../../js/_ResizeObserver.ts" />

import Component from '../../js/_Component';

const CNAME = 'c-block-downloads';

export default class BlockDownloads extends Component {

	/**
	 * The assigned size at which this table should break down to mobile mode.
	 */
	private breakdownSize: number;

	private cardContainer: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		//this.cardContainer = this.element.querySelector(`.${CNAME}--group-wrapper > .row`);
		this.cardContainer = this.element;

		this.breakdownSize = 1279;

		// Apply/remove the mobile styling at the breakdown size.
		const resizeObserver = new ResizeObserver((elements) => {
			let xWidth = elements[0].contentRect.width;

			if(xWidth < 767) {
				this.cardContainer.classList.remove('m-desktop-small');
				this.cardContainer.classList.remove('m-desktop-big');
				this.cardContainer.classList.add('m-mobile');
				return;
			} else {
				this.cardContainer.classList.remove('m-mobile');
				this.cardContainer.classList.remove('m-desktop-small');
				this.cardContainer.classList.add('m-desktop-big');
				return;
			}
		});
		resizeObserver.observe(this.element);

	}
}

Component.register(BlockDownloads, 'BlockDownloads');